module.exports = __webpack_public_path__ + "img/sign.cde26120.png";